module.exports = __webpack_public_path__ + "static/img/grongnoi_mee_x_me_akegasan.f6a0bf7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/grongnoi_mee_x_me_akegasan.png
// module id = nXy1
// module chunks = 134